export default __webpack_public_path__ + "static/media/quick-banner.9eb1cc55.png";